import { GetServerSideProps, InferGetServerSidePropsType } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useEffect } from 'react';
import getThemeByDomainName from './utils/get-theme-by-domain-name';
import { fetchAppData } from '@src/pages/utils/fetch-app-data';
import getConfigByBrand from '@src/pages/utils/get-config-by-brand';
import { useAppStore } from '@src/store';
import { TagThemeType } from 'types/tag';
const Home = ({
  env
}: InferGetServerSidePropsType<typeof getServerSideProps>) => {
  const {
    TAG_SMARTY_EMBEDDED_KEY
  } = env;
  const {
    setSmartyEmbeddedKey
  } = useAppStore(store => store);
  useEffect(() => {
    setSmartyEmbeddedKey(TAG_SMARTY_EMBEDDED_KEY);
  }, [setSmartyEmbeddedKey, TAG_SMARTY_EMBEDDED_KEY]);
};
export const getServerSideProps: GetServerSideProps = async ({
  req,
  locale = 'en-US'
}) => {
  const domain = req.headers.host;
  const theme = getThemeByDomainName(domain);
  const tagTheme = (theme || process.env.TAG_BRAND_THEME || 'clearchoice') as TagThemeType;
  const brandConfig = getConfigByBrand(tagTheme);
  const appData = await fetchAppData({
    appName: brandConfig.contentfulAppId,
    path: req.url,
    confirmationStepId: process.env.ENVIRONMENT_NAME === 'prod' ? brandConfig.features.confirmationStepId.prod : brandConfig.features.confirmationStepId.stage
  });
  let hasIpBasedCoordinates = false;
  let coordinates = {
    latitude: 0,
    longitude: 0
  };
  if (req.headers['cloudfront-viewer-latitude'] && req.headers['cloudfront-viewer-longitude']) {
    hasIpBasedCoordinates = true;
    coordinates = {
      latitude: parseFloat(req.headers['cloudfront-viewer-latitude'] as string),
      longitude: parseFloat(req.headers['cloudfront-viewer-longitude'] as string)
    };
  }
  return {
    props: {
      config: {
        ...brandConfig
      },
      user: {
        coordinates,
        hasIpBasedCoordinates
      },
      env: {
        ENVIRONMENT_NAME: process.env.ENVIRONMENT_NAME,
        TAG_SMARTY_EMBEDDED_KEY: process.env.TAG_SMARTY_EMBEDDED_KEY
      },
      ...appData,
      ...(await serverSideTranslations(locale, ['index']))
    }
  };
};
export default Home;